import { RootState } from '../../store';

export const selectIsAuthenticated = (state: RootState) => {
    const auth = state.auth;
    return auth.iam.authenticated;
};

export default selectIsAuthenticated;
